<router-outlet />
@if (showOverlay()) {
    <div class="bg-background fixed inset-0 z-9999">
        <app-session-state class="block h-dvh w-full" />
    </div>
}
<p-toast />
